import { render } from "./MapPackgesWidget.vue?vue&type=template&id=e954ef20&scoped=true&ts=true"
import script from "./MapPackgesWidget.vue?vue&type=script&lang=ts"
export * from "./MapPackgesWidget.vue?vue&type=script&lang=ts"

import "./MapPackgesWidget.vue?vue&type=style&index=0&id=e954ef20&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e954ef20"]])

export default __exports__